import React, { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import useSmartExperiencePlace from 'components/Experiences/hooks/useSmartExperiencePlace'
import ExperienceOfferCarousel from './ExperienceOfferCarousel'
import Clickable from 'components/Common/Clickable'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import ExperiencesPageLocationModal from 'components/Experiences/ExperiencesPage/ExperiencesPageLocationModal/ExperiencesPageLocationModal'
import ModalContext from 'contexts/ModalContext'
import IconButton from 'LuxKit/Button/IconButton'

function SmartExperienceOfferCarousel() {
  const place: App.Place | undefined = useSmartExperiencePlace()
  const intl = useIntl()

  const showModal = useContext(ModalContext)

  const openLocationModal = useCallback(() => {
    showModal(<ExperiencesPageLocationModal />)
  }, [showModal])

  const ExperienceHeading = useMemo(() => {
    return intl.formatMessage(
      {
        id: '6lmm1+O4mk',
        defaultMessage: 'Find experiences around <location>{placeName}</location>',
        description: 'Heading for experience offers carousel with clickable location',
      },
      {
        placeName: place?.name || '',
        location: (chunks: React.ReactNode) => (
          <Clickable key="location" onClick={openLocationModal}>
            <HeadingTextBlock
              endIcon={
                <IconButton kind="tertiary" variant="dark" nonInteractable>
                  <LineAngleDownIcon />
                </IconButton>
              }
              variant="heading2alt"
            >
              {chunks}
            </HeadingTextBlock>
          </Clickable>
        ),
      },
    )
  }, [intl, place?.name, openLocationModal])

  return (
    <ExperienceOfferCarousel
      place={place}
      experienceHeading={ExperienceHeading}
    />
  )
}

export default SmartExperienceOfferCarousel
